
import { Tbl_stagioneEdit } from './tbl_stagioneEdit';
import { Tbl_stagioneList } from './tbl_stagioneList';
import { Tbl_stagioneShow } from './tbl_stagioneShow';
import { Tbl_stagioneCreate } from './tbl_stagioneCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_stagioneList,
    edit: Tbl_stagioneEdit,
    show: Tbl_stagioneShow,
    create: Tbl_stagioneCreate,
    icon: MapIcon
};
            